import request from "@utils/request";

export function getDataFastTrade(query) {
    return request({
        url: 'alert/data/fast-trade',
        method: 'get',
        params: query
    })
}
